import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import {isMobileOnly} from 'react-device-detect';
import { getCateListAction } from '../../modules/common/cateModule';
import { useState, useRef } from 'react';
import { groupBy, forEach, remove, concat, findIndex, replace, find } from 'lodash';
import MyEsCateItem from "../../components/es/MyEsCateItem"
import MyEs2CateItem from "../../components/es/MyEs2CateItem"
import { reqEsBrandStep1, setEsMyBrandCate1StepAction, setEsMyInit, setEsMyBudgetAction, setEsMyBrandCate3StepAction, reqEsBrandStep3, setEsMySelBrandStep3Action } from '../../modules/es/esMyModule';
import { useHistory } from 'react-router-dom';
import { reqEsItemListIngAction} from '../../modules/es/esItemModule';
import Footer from "../../components/common/Footer";
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';

const EstimateStepBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw; 
        //padding-top: 60px;   
    `:`
        width: 100%;
        margin: 0 auto;
        padding-top: 80px;
    `};

    .yellow {
        color: #ffc742;
    }
`;

const EstimateStepHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 0 30px 0;
         
    `:`
        width: 1176px;
        margin: 0 auto;
        margin-bottom: 40px;
    `};
    position:relative;

    .title-num {
        //width: 100vw;
        height: 50px;
        color: #cccccc;
        font-family: 'Berkshire Swash';
        font-size: 18px;
        line-height: 1.28;
        padding-top: 8px;

        .num-left {
            margin-right: 8px;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 4px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/arrow_my_title.svg) center center/auto no-repeat;
                vertical-align: 6px;
            }
        }
        .num-right {
            margin-left: 8px;
        }
    }

    .close {
        margin-top: 6px;
        margin-right: -3vw;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
    }
    
    .title {
        ${isMobileOnly?`
        font-size: 22px;
        line-height: 1.45;
        `:`
        font-size: 24px;
        line-height: 1.5;
        `};
        font-family: NotoSansKR;
        font-weight: bold;
        color: #111111;
    }

    .sub {
        font-size: 12px;
        font-weight: normal;
        font-family: NotoSansKR;
        line-height: 2.17;
        color: #cccccc;
    }
`;

const EstimateStepContentsBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const EstimateStepCategoryUlBlock = styled.ul`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    ${isMobileOnly&&"margin-left:0"};

`;

const EstimateStepBottomBlock = styled.div`
    //display: block;
    ${isMobileOnly?`
    position:fixed;
    width: 100vw;
    padding: 20px 10px 30px;
    margin: 0 -4vw; 
    `:`
    position:absolute;
    padding: 20px;
    width: 640px;
    `};
    
    bottom:0;
    z-index: 10;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    border-top: solid 1px #cccccc;
    
    display: ${props => props.display || 'none'};
    background-color: #ffffff;

    .list {
        ${isMobileOnly?`
        padding: 0 18px;
    `:`
        padding: 0 0;
    `};
        
    }

    .title {
        color: #999999;
        //margin: 0 18px 0 16px;
        width: 96px;
        display: inline-block;
    }
    .desc {
        color: #333333;
    }
    .num {
        font-weight: 600;
    }
    .pre {
        border-radius: 4px;
        background-color: #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
    }

    .next {
        border-radius: 4px;
        background-color: #111111;
        text-align: center;
        color: #ffffff;
        height: 52px;
        width: 79%;
        float: right;
    }
`;

const EstimateStepBlankBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    
    ${isMobileOnly?`
    height: 200px;
    `:`
    height: 120px;
    `};
`;

const EstimateStepContentsPCBlock = styled.div`
    width: 1176px;
    margin: 0 auto;
    margin-top: 80px;
    .left_con {
        width: 720px;
        height: 707px;
        float: left;
        position: relative;
        padding: 40px 40px 0px 40px;
        border-radius: 10px;
        border: solid 1px #666666;
        margin-left: 40px;
        ::after {
            content: '';
            display: inline-block;
            width: 48px;
            height: 50px;
            background: url(/assets/images/icon/clip.png) center center/auto no-repeat;
            position: absolute;
            background-size: 48px 50px;
            top: -27px;
            right: 33px;
        }
    }

    .right_con {
        width: 355px;
        float: left;
        margin-left: 20px;
        position: relative;
        height: 707px;

        .title {
            font-size: 18px;
            font-weight: 500;
            line-height: 2;
            color: #333333;
            margin-bottom: 15px;
            line-height: 1.2;
        }

        .step {
            font-size: 20px;
            font-weight: 500;
            color: #111111;
            line-height: 1.2;

            .five {
                font-weight: normal;
                color: #999999;
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #cccccc;
        }

        .sub_title {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #999999;
            padding-left: 20px;
        }

        .sub_content {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            margin-top: 8px;
            padding: 0 20px;
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
        }

        .next {
            border-radius: 4px;
            background-color: #111111;
            text-align: center;
            color: #ffffff;
            height: 52px;
            width: 100%;
            
        }
        .pre {
            border-radius: 4px;
            //background-color: #ececec;
            text-align: center;
            color: #333333;
            height: 52px;
            width: 100%;
            float: left;
            border: solid 1px #cccccc;
            background-color: #ffffff;
        }
    }
`;

const category = isMobileOnly?
[
    {id:11, name:"침실", img:"/assets/images/icon/bed-icon.svg", imgAct:"/assets/images/icon/bed-icon-select.svg", w:"40px",h:"32px"},
    {id:10, name:"거실", img:"/assets/images/icon/living-icon.svg", imgAct:"/assets/images/icon/living-icon-select.svg", w:"32px",h:"32px"},
    {id:14, name:"주방", img:"/assets/images/icon/kitchen-icon.svg", imgAct:"/assets/images/icon/kitchen-icon-select.svg", w:"40px",h:"32px"},
    {id:12, name:"드레스룸", img:"/assets/images/icon/closet-icon.svg", imgAct:"/assets/images/icon/closet-icon-select.svg", w:"32px",h:"32px"},
    {id:15, name:"아이방", img:"/assets/images/icon/kids-icon.svg", imgAct:"/assets/images/icon/kids-icon-select.svg", w:"38px",h:"32px"},
    {id:13, name:"서재·홈오피스", img:"/assets/images/icon/office-icon.svg", imgAct:"/assets/images/icon/office-icon-select.svg", w:"48px",h:"32px"},
    {id:16, name:"가전", img:"/assets/images/icon/elec.svg", imgAct:"/assets/images/icon/elec-select.svg", w:"21px",h:"32px"},
]
:
[
    {id:11, name:"침실", img:"/assets/images/icon/bed-icon.svg", imgAct:"/assets/images/icon/bed-icon-select.svg", w:"40px",h:"32px"},
    {id:10, name:"거실", img:"/assets/images/icon/living-icon.svg", imgAct:"/assets/images/icon/living-icon-select.svg", w:"32px",h:"32px"},
    {id:14, name:"주방", img:"/assets/images/icon/kitchen-icon.svg", imgAct:"/assets/images/icon/kitchen-icon-select.svg", w:"40px",h:"32px"},
    {id:12, name:"드레스룸", img:"/assets/images/icon/closet-icon.svg", imgAct:"/assets/images/icon/closet-icon-select.svg", w:"32px",h:"32px"},
    {id:13, name:"서재·홈오피스", img:"/assets/images/icon/office-icon.svg", imgAct:"/assets/images/icon/office-icon-select.svg", w:"48px",h:"32px"},
    {id:15, name:"아이방", img:"/assets/images/icon/kids-icon.svg", imgAct:"/assets/images/icon/kids-icon-select.svg", w:"38px",h:"32px"},
    {id:16, name:"가전", img:"/assets/images/icon/elec.svg", imgAct:"/assets/images/icon/elec-select.svg", w:"21px",h:"32px"},
]

const EstimateStep1 = () => {

    const dispatch = useDispatch();
    const [arrCategory, setArrCategory] = useState([]);
    const [selId, setSelId] = useState(-1);
    const refContainer = useRef(null);
    const history = useHistory();
    const [cate2Item, setCate2Items] = useState("");
    const [openModal, setOpenModal] = useState(false);

    const { categoryItems, error ,esMyBrandCate1Step, esBrandMyStep1, esBrandMyStep3} = useSelector(
        ({ cateItemsReducer, esMyReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            error: cateItemsReducer.error,
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esBrandMyStep1: esMyReducer.esBrandMyStep1,
            esBrandMyStep3:esMyReducer.esBrandMyStep3,
        })
    );

    useEffect(() => {
        //console.log("esMyBrandCate1Step = " + JSON.stringify(esMyBrandCate1Step))
        if(esMyBrandCate1Step ) {
            dispatch(reqEsBrandStep1(esMyBrandCate1Step));
            dispatch(setEsMyBrandCate3StepAction(esMyBrandCate1Step));
            dispatch(reqEsBrandStep3(esMyBrandCate1Step, 0));
        }
        
        //console.log('arrCategory = ' + JSON.stringify(arrCategory))

        if(!isMobileOnly&&esMyBrandCate1Step&&arrCategory&&arrCategory.length>0) {
            let txtCate2 = "";
            forEach(arrCategory, (curobj, index) => {
                let cate = curobj.category;
                //console.log('cate = ' + JSON.stringify(cate))
                if(cate !== null && cate !== undefined) {
                    let cate1Id = cate.id*100;
                    forEach(cate.cate2, (cate2, index) => {
                        let cateId = cate1Id + cate2.id*1;
                        for(let i =0 ; i < esMyBrandCate1Step.length; i++){
                            if(esMyBrandCate1Step[i] === cateId) {
                                if(txtCate2.length === 0) {
                                    txtCate2 = cate2.cate_name + "";
                                } else {
                                    txtCate2 = txtCate2 + ", "+cate2.cate_name;
                                }
                            }
                        }
                    });
                }
                
            });

            //console.log("txtCate2 = " + txtCate2)
            setCate2Items(txtCate2);
        }

    }, [esMyBrandCate1Step, arrCategory]);


    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        } else {
            let arr = [];
            Object.assign(arr, category);
            forEach(arr, (curobj, index) => {
                for(let i = 0; i < categoryItems.length ; i++) {
                    if(curobj.id === categoryItems[i].id) {
                        let cate = {};
                        Object.assign(cate, categoryItems[i]);
                        curobj.category = cate;
                        break;
                    }
                }
            });
            //console.log('cate = ' + JSON.stringify(arr))
            setArrCategory(arr);
        }

    }, [categoryItems]);

    /* useEffect(() => {
        
         //Alert if clicked on outside of element
         
        function handleClickOutside(event) {
            if (refContainer.current && !refContainer.current.contains(event.target)) {
                setSelId(-1)
            }
        }
    
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [refContainer]); */

    // 최소 실행시 Header 관련 처리 추가  
    useEffect(() => {
        dispatch(setCurMenuAction('esapply'));
        dispatch(setHeaderTransferAction(false));
        dispatch(reqEsItemListIngAction());// 견적정보 get
        
        //console.log("action = " + history.action)
        if(history.action !== 'POP'){
            let data = [];
            //dispatch(setEsMyBrandCate1StepAction(data));
        } 

        if(history.action === 'PUSH'){
            //dispatch(setEsMyInit());
            if(esMyBrandCate1Step&&esMyBrandCate1Step.length>0) {
                setOpenModal(true);
            } else {
                dispatch(setEsMyInit());
            }
        } 
        //2단계 초기화
        //dispatch(setEsMyBudgetAction(0));
    }, []);

    useEffect(() => {
        if(esBrandMyStep3) {
            let checkInfo = [];
            esBrandMyStep3&&esBrandMyStep3.length>0&&esBrandMyStep3.map((info,index) => {
                
                let brndinfo = {brnd_id:info.brand.brnd_id, brnd_han:info.brand.brnd_han, cateString:''}
                checkInfo.push(brndinfo);
            })

            //console.log("EsMySelBrandStep3 = " + JSON.stringify(checkInfo))
            dispatch(setEsMySelBrandStep3Action(checkInfo));
        }

    }, [esBrandMyStep3]);

    const handleFistCateClick = (id) => {
        if(id === selId) {
            setSelId(-1)
        } else {
            setSelId(id);
        }
    }

    const handlePre = () => {
        //setOpenModal(true);
        history.goBack();
    }

    const handleNext = () => {
        history.push("/estimate/step2");
    }

    const getActiveStatus = (index) =>{
        if(isMobileOnly) {
            if(index === 1 && (selId===arrCategory[0].id || selId===arrCategory[1].id || selId===arrCategory[2].id)) {
                return true;
            } else if(index === 2 && (selId===arrCategory[3].id || selId===arrCategory[4].id)) {
                return true;
            } else if(index === 3 && (selId===arrCategory[5].id || selId===arrCategory[6].id)) {
                return true;
            }
        } else {
            if(index === 1 && (selId===arrCategory[0].id || selId===arrCategory[1].id || selId===arrCategory[2].id || selId===arrCategory[3].id)) {
                return true;
            } else if(index === 2 && (selId===arrCategory[5].id || selId===arrCategory[6].id || selId===arrCategory[4].id)) {
                return true;
            } 
        }
        
        return false;
    }

    const getActiveCategory = () => {
        let category = null;
        if(arrCategory.length < 1) {
            return category;
        }

        for (let i = 0; i < arrCategory.length; i++) {
            if(selId === arrCategory[i].id) {
                category = arrCategory[i].category;
                break;
            }
        }

        return category;
    }

    const handleModalBtn1Click = () => {
        setOpenModal(false);
    }

    // 닫기
    const handleModalBtn2Click = () => {
        dispatch(setEsMyInit());
        setOpenModal(false);
    }

    const getPopup = () => {
        let msg = "선택해 놓으신 데이터가 있습니다.";
        return (<NormalPopup
            text={""}
            text2={msg}
            text3={""}
            btn1="불러오기" btn2="다시하기"
            onClick1={handleModalBtn1Click}
            onClick2={handleModalBtn2Click} />)

    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

    if(arrCategory === null || arrCategory.length < 1) {
        return <div></div>
    }
    return (isMobileOnly ?
            <EstimateStepBlock>
                
                {/* <Header /> */}
                <EstimateStepHeaderBlock className="clearfix">
                    <div className="clearfix">
                    <div className="title-num f-left"><span className="num-left">1</span><span>4</span></div>{/* <div className="close f-right"></div> */}
                    </div>
                    <div className="title"><p><span className="yellow">어떤 상품</span>이</p><p>필요한가요?</p></div>
                    <div className="sub">나만의 상품 견적 알아보기</div>

                </EstimateStepHeaderBlock>
                <EstimateStepContentsBlock ref={refContainer}>
                    <EstimateStepCategoryUlBlock>
                        <MyEsCateItem data={arrCategory[0]} maxWidth={"30vw"} marginRight={"2vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[0].id}  selId={selId}/>
                        <MyEsCateItem data={arrCategory[1]} maxWidth={"28vw"} marginRight={"2vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[1].id} selId={selId}/>
                        <MyEsCateItem data={arrCategory[2]} maxWidth={"30vw"} marginRight={"0vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[2].id} selId={selId}/>
                    </EstimateStepCategoryUlBlock>
                    <MyEs2CateItem category={getActiveCategory()} active={getActiveStatus(1)}/>
                    <EstimateStepCategoryUlBlock>
                        <MyEsCateItem data={arrCategory[3]} maxWidth={"45vw"} marginRight={"2vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[3].id} selId={selId}/>
                        <MyEsCateItem data={arrCategory[4]} maxWidth={"45vw"} marginRight={"0vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[4].id} selId={selId}/>
                    </EstimateStepCategoryUlBlock>
                    <MyEs2CateItem category={getActiveCategory()} active={getActiveStatus(2)}/>
                    <EstimateStepCategoryUlBlock>
                        <MyEsCateItem data={arrCategory[5]} maxWidth={"52vw"} marginRight={"2vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[5].id} selId={selId}/>
                        <MyEsCateItem data={arrCategory[6]} maxWidth={"40vw"} marginRight={"0vw"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[6].id} selId={selId}/>
                    </EstimateStepCategoryUlBlock>
                    <MyEs2CateItem category={getActiveCategory()} active={getActiveStatus(3)}/>
                    {/* <EstimateStepCategoryUlBlock>
                    {
                        arrCategory.map((curitem, index) => {
                            return (<MyEsCateItem
                                data={curitem} />)
                        })
                    }
                    </EstimateStepCategoryUlBlock> */}
                    
                </EstimateStepContentsBlock>
                <EstimateStepBlankBlock >&nbsp;</EstimateStepBlankBlock>
            <EstimateStepBottomBlock display={esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}>
                <div className="list margin_b-10"><span className="title">보유 브랜드</span><span>{esBrandMyStep1&&esBrandMyStep1.brand} 외</span><span className="num"> {esBrandMyStep1&&(esBrandMyStep1.length-1)}</span>개</div>
                <div className="list margin_b-20"><span className="title">선택 품목 금액</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                <button className="pre" onClick={handlePre}>나가기</button><button className="next" onClick={handleNext}>다음</button>
            </EstimateStepBottomBlock>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
        </EstimateStepBlock>
        :
        <EstimateStepBlock>
            
                <Header />
                <EstimateStepContentsPCBlock className="clearfix">
                    <div className="left_con clearfix">
                        <EstimateStepHeaderBlock className="clearfix">
                        <div className="title"><p><span className="yellow">어떤 상품</span>이 필요한가요?</p></div>
                        </EstimateStepHeaderBlock>
                        <EstimateStepContentsBlock ref={refContainer}>
                            <EstimateStepCategoryUlBlock>
                                <MyEsCateItem data={arrCategory[0]} maxWidth={"30vw"} marginRight={"20px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[0].id}  selId={selId}/>
                                <MyEsCateItem data={arrCategory[1]} maxWidth={"28vw"} marginRight={"20px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[1].id} selId={selId}/>
                                <MyEsCateItem data={arrCategory[2]} maxWidth={"30vw"} marginRight={"20px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[2].id} selId={selId}/>
                                <MyEsCateItem data={arrCategory[3]} maxWidth={"45vw"} marginRight={"0px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[3].id} selId={selId}/>
                            </EstimateStepCategoryUlBlock>
                            <MyEs2CateItem category={getActiveCategory()} active={getActiveStatus(1)}/>
                            <EstimateStepCategoryUlBlock>
                                <MyEsCateItem data={arrCategory[5]} maxWidth={"52vw"} marginRight={"20px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[5].id} selId={selId}/>
                                <MyEsCateItem data={arrCategory[4]} maxWidth={"45vw"} marginRight={"20px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[4].id} selId={selId}/>
                                <MyEsCateItem data={arrCategory[6]} maxWidth={"40vw"} marginRight={"0px"} handleFistCateClick={handleFistCateClick} active={selId===arrCategory[6].id} selId={selId}/>
                            </EstimateStepCategoryUlBlock>
                            <MyEs2CateItem category={getActiveCategory()} active={getActiveStatus(2)}/>
                        </EstimateStepContentsBlock>
                        <EstimateStepBottomBlock display={esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}>
                            <div className="list margin_b-10"><span className="title">보유 브랜드</span><span>{esBrandMyStep1&&esBrandMyStep1.brand} 외</span><span className="num"> {esBrandMyStep1&&(esBrandMyStep1.length-1)}</span>개</div>
                            <div className="list margin_b-20"><span className="title">선택 품목 금액</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                            <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                        </EstimateStepBottomBlock>
                    </div>
                    <div className="right_con clearfix">
                        <div className="title">나만의 상품 견적 알아보기</div>
                        <div className="step margin_b-40"><span>Step 1 </span><span className="five">/ 4</span></div>
                        <div className="line margin_b-20" />
                        <div className="sub_title">1. 카테고리</div>
                        <div className="sub_content">{cate2Item}</div>
                        <div className="line margin_t-20" />
                        <div className="bottom">
                            <button className="next margin_b-10" onClick={handleNext} style={{display:esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}}>다음</button>
                            <button className="pre" onClick={handlePre}>나가기</button>
                        </div>
                    </div>
                </EstimateStepContentsPCBlock>
                
                <EstimateStepBlankBlock >&nbsp;</EstimateStepBlankBlock>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
            <Footer siteMovePosition={isMobileOnly?'80px':'50px'} />
        </EstimateStepBlock>
    );
};

export default EstimateStep1;
